// uploadFiles
// wrapper for blueimp uploader

bq.uploadFiles = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.fileEl    = false;
  this.listing   = false;
  this.templates = {};
  this.currentXHR = false;
  this.ajaxUpload = true;
};

bq.uploadFiles.DEFAULTS = {
  uploadUrl: '', //required for AJAX
  replaceFileInput: false,
  removeUrl: '',
  updateUrl: '',
  reloadUrl: '',
  ajaxParams: {},
  sequential: true,
  singleFileUpload: false,
  ajaxUpload: true,
  fileListing: '.attachment-block-files tbody',
  dropZoneSelector: null,
  dropZone: null,
  singleButton: '.attachment-button-zone',
  input: '.attachment-file-upload',
  maxNumberOfFiles: 1, //used for non-ajax only, ajax is unlimited
  updateType: 'button', //button, input or false
  showProgress: false, //not implemented at this time
  messages: {
    cancel: bq.messages.global.cancel,
    remove: bq.messages.global.remove,
    aborted: bq.messages.global.uploadAborted,
    maxNumberOfFilesError: bq.messages.global.maxNumberOfFiles
  },
  newTemplate: '<tr data-ui-id="{{file__uiId}}"><td class="upload-file-select"></td><td class="upload-file-name">{{file__name}}</td><td class="progress-container" colspan="2">{{progress}}</td></tr>',
  progressTemplate: '<div class="progress progress-striped active"><div class="progress-bar" role="progressbar" aria-valuenow="{{complete}}" aria-valuemin="0" aria-valuemax="100" style="width: {{complete}}%"></div></div>',
  completeTemplate: '<tr data-ui-id="{{file__uiId}}" data-file-id="{{file__id}}"><td class="attachment-file-input">{{file__input}}</td><td class="attachment-file-link">{{file__link}}<br><small>{{file__upload_by}} @ {{file__upload_at}}</small></td><td class="attachment-file-size">{{file__display_size}}</td><td class="{{file__actionTdClass}}">{{action__remove}}</td></tr>',
  errorTemplate: '<tr data-ui-id-error="{{file__uiId}}"><td class="upload-file-select"></td><td class="upload-file-name upload-file-error">{{file__name}}<br><small class="text-danger">{{file__error}}</small></td><td></td><td class="{{file__actionTdClass}}">{{action__remove}}</td></tr>',
  nonAjaxTemplate: '<tr data-ui-id="{{file_uiId}}"><td class="upload-file-name" colspan="3">{{file__name}}</td><td class="upload-file-action {{file__actionTdClass}}">{{action__remove}}</td></tr>',
  templateEngine: bq.helper.templateEngine
};

bq.uploadFiles.prototype = {

  init: function(opt) {
    bq.debug.log("Upload Files : init()", this.$element);

    this.ajaxUpload = this.options.ajaxUpload;

    if((this.ajaxUpload) && (this.options.uploadUrl.length <= 0)) { //if no url or type exit
      bq.debug.error("Upload Files : required data-* missing", this);
      return;
    }

    //build templates
    this.templates.newFile = this.options.templateEngine.compile(this.options.newTemplate);
    this.templates.progress = this.options.templateEngine.compile(this.options.progressTemplate);
    this.templates.completeFile = this.options.templateEngine.compile(this.options.completeTemplate);
    this.templates.errorFile = this.options.templateEngine.compile(this.options.errorTemplate);
    this.templates.nonAjaxFile = this.options.templateEngine.compile(this.options.nonAjaxTemplate);
    //attach file upload plugin to our input
    var uploadOptions = this._getUploadOptions();
    this.fileEl = $(this.options.input, this.$element);

    //check if passed ID selector
    if (this.options.fileListing.indexOf("#") > -1) {
      this.listing = $(this.options.fileListing);
    } else {
      this.listing = $(this.options.fileListing, this.$element);
    }

    this.initData = this.$element.data('initData');
    this._updateSubmitState();

    this.fileEl.fileupload(uploadOptions);

    if(!this.options.dropZone) {
        this.options.dropZoneSelector = this.options.singleButton;
    }

    //add events
    $(this.options.dropZone, this.$element).on('click bq.upload.addfile', {context: this}, this._catchAddFileEvent);
    this.$element.parents('form').on('reset', {context: this}, this._catchFormResetEvent);
    this.fileEl.bind('fileuploadadd', {context:this}, this._catchFileAddedEvent);
    this.fileEl.bind('fileuploadsend', {context:this}, this._catchFileSendEvent);
    this.fileEl.bind('fileuploadalways', {context:this}, this._catchFileDoneEvent);

    if(this.options.showProgress) {
      //this.fileEl.bind('fileuploadprogress', {context:this}, this._catchFileSendEvent); //not implimented at this time
    }

    //Disabling drag and drop until IE11 issues can be revisited
    Array.prototype.slice.call(this.$element[0].querySelectorAll('.attachment-file-upload')).forEach(function(el){
      el.addEventListener('drop', function(e){
        e.preventDefault();
        return false;
      });
    });

    this._addFileEvents();

    this.renderInitData();
  },

  renderInitData: function() {
    if (this.options.reloadUrl.length <= 0) {
      return;
    }

    var item = jQuery('tr[data-item-id="'+ this.options.ajaxParams.entity_id + '"]')[0];
    if (item && !(parseInt(item.attributes['data-item-webform-id'].value, 10) > 0)) {
      return;
    }

    var params = $.extend(this.options.ajaxParams, {ajax: true}),
        $this = this;
    $.getJSON(this.options.reloadUrl, params)
        .always(function(data, textStatus, jqXHR) {
          if(!data || textStatus != 'success') {
            return;
          }
          //foreach receivedData
          if(typeof data !== 'object') {
            data = $.parseJSON(data);
          }
          $.each(data, function(index, itemData) {
            itemData = $this._gatherTemplateData(itemData, 'attachment_' + ++bq.helper.uniqueIdCounter, true);

            var el = '';
            el = $this.templates.completeFile.render(itemData);
            el = $(el);
            $this._addEvents(el);
            $this.listing.append(el);
          });
          if($this.listing.find('tr').length > 0) {
            $this.$element.find('.attachment-block-table-actions.hide').removeClass('hide');
          }
        });

    this._canStillUpload();
  },

  _getUploadOptions: function() {
    bq.debug.log("Upload Files : _getUploadOptions()");
    var tmpOptions = {};

    if(this.ajaxUpload) {
      tmpOptions.url = this.options.uploadUrl;
    } else {
      tmpOptions.autoUpload = false;
      tmpOptions.maxNumberOfFiles = this.options.maxNumberOfFiles;
      tmpOptions.getNumberOfFiles = this._currentFileCount.bind(this);
      tmpOptions.singleFileUploads = false;//this.options.singleFileUpload;
    }
    tmpOptions.replaceFileInput = this.options.replaceFileInput;
    //tmpOptions.fileInput =
    //tmpOptions.limitMultiFileUploads
    //tmpOptions.autoUpload
    //tmpOptions.singleFileUploads = this.options.singleFileUpload;
    tmpOptions.sequentialUploads = this.options.sequential;
    tmpOptions.formData = this.options.ajaxParams;
    tmpOptions.dropZone = null; // Set to null or an empty jQuery collection to disable drag & drop support
    tmpOptions.dataType = 'text';
    return tmpOptions;
  },

  _createNewFile: function(file, context) {
    bq.debug.log("Upload Files : _createNewFile()", 'file: ', file, ' context: ', context);
    var data = this._gatherTemplateData(file, context, false);
    var el = '';
    if(this.ajaxUpload && data.file.error === undefined) {
      el = this.templates.newFile.render(data);
    } else if(!this.ajaxUpload && data.file.error === undefined) {
      el = this.templates.nonAjaxFile.render(data);
    } else {
       el = this.templates.errorFile.render(data);
    }
    el = $(el);
    this._addEvents(el);
    this.listing.append(el);
    this.$element.find('.attachment-block-table-actions.hide').removeClass('hide');
    this._canStillUpload();
  },

  _updateProgress: function(id, percent) {
    bq.debug.log("Upload Files : _updateProgress()", ' id: ', id, ' percent: ', percent);
    var html = this.templates.progress.render({complete:percent});
    $('[data-ui-id="'+id+'"]', this.$element).find('.progress-container').html(html);
  },

  _canStillUpload: function() {
    if (this.options.ajaxUpload) {
      $(this.options.input, this.$element).val('');
      return;
    } //ajax is unlimited

    var current = this._currentFileCount(),
        allowed = this.options.maxNumberOfFiles;

        if(current >= allowed) {
            $(this.options.dropZone, this.$element).hide();
        } else {
            $(this.options.dropZone, this.$element).show();
            $(this.options.input, this.$element).val('');
        }
  },

  _processResults: function(id, name, result, textStatus, jqXHR) {
    bq.debug.log("Upload Files : _processResults()", ' id: ', id, ' name: ', name);

    if(typeof result !== 'object') {
      result = $.parseJSON(result);
    }

    var data = this._gatherTemplateData(result, id, false);
    var el = '';
    if(result.error) {
      result.name = name;
      el = this.templates.errorFile.render(data);
      el = $(el);
    } else {
      el = this.templates.completeFile.render(data);
      el = $(el);
    }

    this._addEvents(el);
    this.listing.find('[data-ui-id="'+id+'"]').replaceWith(el);

  },

  _gatherTemplateData: function(file, id, active) {
    bq.debug.log("Upload Files : _gatherTemplateData()", ' file: ', file, ' id: ', id, ' active: ', active);
    var data = {},
        percent = active ? '100' : '0';

    data.file = file;
    data.file.uiId = id;
    data.file.actionTdClass = bq.getIsThemeNew() ? 'text-right' : '';
    data.progress = this.templates.progress.render({complete:percent});
    data.action = {
      cancel: '<a href="javascript:void(0);" class="action-cancel">'+this.options.messages.cancel+'</a>',
      remove: this._getRemoveActionHtml()
    };
    return data;
  },

  _getRemoveActionHtml: function() {
    if (bq.getIsThemeNew()) {
      return '<a href="javascript:void(0);" data-remove="true"><button type="button" class="action-icon-circle delete margin-top-negative-5" aria-label="Remove"><span aria-hidden="true" class="fa fa-trash-o"></span></button></a>';
    }

    return '<a href="javascript:void(0);" data-remove="true">' + this.options.messages.remove + '</a>';
  },

  _call: function(url, id, type, param) {
    bq.debug.log("Upload Files : _call()");

    if(!url) { $this._rollback(id, type); return; }

    if(!id && type !== 'update') { return; }
    if(!param) { params = {}; }

    var params = $.extend(this.options.ajaxParams, param, {file_id: id, ajax: true}),
        $this = this;

    $.getJSON(url, params)
      .always(function(data, textStatus, jqXHR) {
        if(!data || textStatus != 'success') {
          $this._rollback(id, type);
          return;
        }

        $this._processCall(id, type, data);
      });
  },

  _processCall: function(id, type, data) {
    bq.debug.log("Upload Files : _processCall()");
    if(data.error) {
      this._rollback(id, type);
      return;
    }

    if(type === 'remove' && data.success) {
      this.$element.find('[data-file-id="'+id+'"]').remove();
    }

    if(type === 'update' && data.success) {
      this._rollback(id, 'false');
      this._updateInputs(data);
    }

    if(this.listing.find('tr').length <= 0) {
      this.$element.find('.attachment-block-table-actions').addClass('hide');
    }

    this._canStillUpload();
    this._updateSubmitState();
  },

  _rollback: function(id, type) {
    bq.debug.log("Upload Files : _rollback()");

    if(type == 'update' && this.options.updateType == 'button' || !id && type == 'false') {
      this.$element.find('[data-update="true"]').removeClass('disable').data('ajaxActive', false);
      var el = this.$element.find('[data-file-id]');
      el.data('ajaxActive', false).removeClass('disable');
    } else {
      var el = this.$element.find('[data-file-id="'+id+'"]');
      el.data('ajaxActive', false).removeClass('disable');

      if(type == 'update') {
        var checkBoxes = el.find('input[type="checkbox"]');
        checkBoxes.prop("checked", !checkBoxes.prop("checked"));
      }
    }
  },

  _remove: function(row) {
    bq.debug.log("Upload Files : _remove()");
    var id = row.data('fileId');
    if(!id || row.data('ajaxActive') === true) {
      row.remove();
      return;
    }
    row.addClass('disable').data('ajaxActive', true);
    this._call(this.options.removeUrl, id, 'remove');
  },

  _update: function(row, group) {
    bq.debug.log("Upload Files : _update()");

    if(!group && row) {
      var id = row.data('fileId');
      if(!id || row.data('ajaxActive') === true) { return; }
      row.addClass('disable').data('ajaxActive', true);


      var $checked = row.find('input[type="checkbox"]');
      var val = false;
      if($checked.prop("checked")) { val = $checked.val(); } else { val = $checked.data('unValue'); }
      var params = {send_type: val};

      this._call(this.options.updateUrl, id, 'update', params);
    }

    if(group) {
      var button = row;
      if(button.data('ajaxActive') === true) { return; }
      button.addClass('disable').data('ajaxActive', true);
      var el = this.$element.find('[data-file-id]');

      var $this = this;
      var params = [];

      el.each(function() {
        var row = $(this);
        var input = row.find('input[type="checkbox"]');
        if(input.is(':enabled')) {
          var id = row.data('fileId');
          var val = false;
          if(input.prop("checked")) { val = input.val(); } else { val = input.data('unValue'); }
          row.data('ajaxActive', true).addClass('disable');
          params.push({id: id, val: val});

        }
      });

      this._call(this.options.updateUrl, false, 'update', {send_type: params});
    }
  },

  _updateInputs: function(data) {
    bq.debug.log("Upload Files : _updateInputs()");
    var $this = this;

    if(data.send_type_results) {
      $.each(data.send_type_results, function(k, row) {
        $('[data-file-id="'+row.id+'"] input[type="checkbox"]', $this.$element).closest('td').html(row.input);
      });
    }
  },

  _currentFileCount: function() {
    return this.listing.find('[data-ui-id]').length;
  },

  _addEvents: function(el) {
    bq.debug.log("Upload Files : _addEvents()");
    var input = this.options.input;
    if(this.ajaxUpload) {
      el.find('.action-cancel').on('click', {context:this, xhr: this.currentXHR}, this._catchCancelEvent);
      el.find('[data-remove="true"]').on('click', {context:this, xhr: this.currentXHR}, this._catchRemoveEvent);
    } else {
      el.find('.action-cancel').on('click', {context:this}, function(e){
        $(input).val('').trigger('change');
        $(this).closest('tr').remove();
        e.data.context._canStillUpload();
      });
      el.find('[data-remove="true"]').on('click', {context:this}, function(e){
        $(input).val('').trigger('change');
        $(this).closest('tr').remove();
        e.data.context._canStillUpload();

        jQuery('#react-app-page').trigger('fileDeleted');
      });
    }
    if(this.options.updateType == 'input') {
      el.find('input:enabled').on('change', {context:this}, this._catchUpdateEvent);
    }
    el.find('input[type="checkbox"]').on('change', {context: this}, this._updateTextDanger);
  },

  _addFileEvents: function() {
    bq.debug.log("Upload Files : _addFileEvents()");
    this.$element.find('[data-remove="true"]').on('click', {context:this}, this._catchRemoveEvent);
    if(this.options.updateType == 'input') {
      this.listing.find('input:enabled').on('change', {context:this}, this._catchUpdateEvent);
      this.$element.find('[data-update="true"]').addClass('hide');
    }

    if(this.options.updateType == 'button') {
      this.$element.find('[data-update="true"]').on('click', {context:this}, this._catchUpdateEvent);
    }
    $('input[type="checkbox"]', this.$element).on('change', {context: this}, this._updateTextDanger);
  },

  _catchFileAddedEvent: function(e, data) {
    bq.debug.log("Upload Files : _catchFileAddedEvent()");
    var $this = e.data.context,
        id = ++bq.helper.uniqueIdCounter;
    data.context = 'attachment_'+id;
    $this.currentXHR = data;
    if($this.options.singleFileUpload) {
        var singleFile = data.files[0];
        if(singleFile) {
            if (singleFile.error == $this.options.messages.maxNumberOfFilesError) {
                singleFile.error = undefined;
                $this.listing.find('tr:last-child').remove();
            }
            $this._createNewFile(singleFile, data.context);
            jQuery('#react-app-page').trigger('fileUploaded');
        }
    } else {
        $.each(data.files, function() {
            $this._createNewFile(this, data.context);
        });
    }
  },

  _catchCancelEvent: function(e) {
    bq.debug.log("Upload Files : _catchCancelEvent()");
    var $this = e.data.context,
        $data = e.data.xhr;
    $data.abort();
  },

  _catchRemoveEvent: function(e) {
    bq.debug.log("Upload Files : _catchRemoveEvent()");
    var $this = e.data.context;
    $this._remove($(this).closest('tr'));
    //add code to remove
  },

  _catchUpdateEvent: function(e) {
    bq.debug.log("Upload Files : _catchUpdateEvent()");
    var $this = e.data.context;
    $this._updateTextDanger(e);
    if($this.options.updateType == 'input') {
      $this._update($(this).closest('tr'), false);
    }

    if($this.options.updateType == 'button') {
      $this._update($(this), true);
    }

  },

  _catchFileSendEvent: function(e, data) {
    bq.debug.log("Upload Files : _catchFileSendEvent()");
    var $this = e.data.context,
        id = data.context;
    $this.currentXHR = data;
    $this._updateProgress(id, '100');
  },

  _catchFileDoneEvent: function(e, data) {
    bq.debug.log("Upload Files : _catchFileDoneEvent()", ' e: ', e, ' data: ', data);
    var $this = e.data.context,
        id = data.context;
    $this.currentXHR = data;
    if(data.errorThrown === "abort") {
      data.result = {
        name: data.files[0].name,
        size: 0,
        error: $this.options.messages.aborted,
        uiId: data.context
      };
      data.jqXHR = false;
    }
    $this._processResults(id, data.files[0].name, data.result, data.textStatus, data.jqXHR);
    $this._updateSubmitState();
  },

  _catchAddFileEvent: function(e) {
    bq.debug.log("Upload Files : _catchAddFileEvent()");
    var $this = e.data.context;
    $this.fileEl.fileupload();
  },

  _catchFormResetEvent: function(e) {
    bq.debug.log("Upload Files : _catchFormResetEvent");
    var $this = e.data.context;
    $this.listing.empty();
  },

  _updateSubmitState: function() {
    const $form = this.$element.closest('.bq-form');
    const changed = JSON.stringify(this.initData) !== this._getListingJSON();
    $form.trigger('bq:submit-vote', { plugin: 'upload', allow: changed });
  },

  _getListingJSON: function() {
      const ids = this.listing
          .find('tr[data-file-id]')
          .map(function (_, tr) {
              return $(tr).data('fileId');
          })
          .get()
          .filter(v => v != null);

      ids.sort((a, b) => Number(a) - Number(b));
      return JSON.stringify(ids);
  },

  _updateTextDanger: function (e) {
    var $this = e.data.context;
    if ($this.options.updateTextDanger) {
      $this.$element.find('.text-danger').html(
          $this.options.textDangerMessage
      );
      $this.options.updateTextDanger = false;
    }
  }
};


// uploadFiles PLUGIN DEFINITION
// =======================

var uploadFilesold = $.fn.uploadFiles;

$.fn.uploadFiles = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.uploadFiles');
    var options = $.extend({}, bq.uploadFiles.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.uploadFiles', (data = new bq.uploadFiles(this, options))); }
    data.init();
  });
};

$.fn.uploadFiles.Constructor = bq.uploadFiles;

// uploadFiles NO CONFLICT
// =================

$.fn.uploadFiles.noConflict = function () {
  $.fn.uploadFiles = uploadFilesold;
  return this;
};

// uploadFiles DATA-API
// ==============

bq.uploadFilesInit = function() {
  $('[data-bq="uploadFiles"]').each(function () {
    var el = $(this);
    if(el.data('bq.uploadFiles')) { return; }
    el.uploadFiles(el.data());
  });
};

bq.init.push(bq.uploadFilesInit);

//bq.reloadDataOnInit = function() {
//  $('[data-bq="uploadFiles"]').each(function () {
//    bq.debug.log("reloadDataOnInit : init()", this);
//    var el = $(this);
//    if (el.data('bq.uploadFiles')) {
//      bq.uploadFiles.reloadData(el);
//    }
//  });
//};
//bq.init.push(bq.reloadDataOnInit);

//setTimeout(reloadDataOnInit,0);
